import type { EmployeeViewModelWithName } from '../../types';
import type { LocalDate } from '../../../utilities/local-date';
import type { FunctionViewModel, TaskViewModel } from '@trinnvis/dabih-api-client';
import { RecurrenceRule } from '../../recurrence-rule/recurrence-rule';
import { displayName } from '../../../utilities/text';
import { sortBy } from 'lodash';
import type { StaffingEmployeeDayTask } from '../../../pages/staffing-page/staffing-employee-day-task';

export function calculateTasksForEmployeeDate(
  employee: EmployeeViewModelWithName,
  localDate: LocalDate,
  functions: FunctionViewModel[],
  tasks: TaskViewModel[],
): StaffingEmployeeDayTask[] {
  const employeeFunctions = functions.filter((f) => f.employees.includes(employee.uuid)).map((item) => item.uuid);
  const until = localDate.plusDays(1);
  let t: StaffingEmployeeDayTask[] = [];
  tasks.forEach(function (task) {
    if (employeeFunctions.includes(task.functionUuid) && task.rrule && !task.locked) {
      const rrule = RecurrenceRule.fromString(task.rrule);
      const instances = rrule.between(localDate, until);
      const dayTask = task.rrule.indexOf('BYHOUR') < 0;
      instances.forEach(function (instance) {
        let hours = '';
        if (!dayTask) {
          hours = rrule.formattedTime('');
        }
        t.push({
          uuid: task.uuid,
          name: displayName(task.name),
          functionUuid: task.functionUuid,
          time: instance,
          dayTask: dayTask,
          hours: hours,
        });
      });
    }
  });
  t = sortBy(t, [(item) => item.time.toEpochDay()]);

  return t;
}
